import { ActiveCompetitionSelector } from "shared/reducers/CompetitionActionPanel";
import { useDispatch, useSelector } from "react-redux";
import { useModal } from "core";
import { CompetitionActionPanelActions } from "shared/reducers/CompetitionActionPanel";
import urlApi from "shared/actions/urlApi";
import { ProjectAPI } from "@brg/api";
import { useToasts } from "@brg/ui";
import { CreateLinkTo } from "shared/constants/linkTo";
import { useHistory } from "react-router-dom";
import useQueryState from "./useQueryState";
import useCompetitionActions from "./useCompetitionActions";
import { useEffect } from "react";

const useCompetitionPanelActions = ({ projectId }: { projectId: string }) => {
    const activeCompetition = useSelector(ActiveCompetitionSelector);

    const { 
        onApplyClick, 
        setSelectedProjects, 
        getLegalsModal,
        needToFillForm
    } = useCompetitionActions(activeCompetition);

    useEffect(() => {
        setSelectedProjects([projectId]);
    }, [projectId]);
    
    const sendProjectToCompetition = ({
        projectId,
        shouldPublish,
    }: { projectId: string, shouldPublish: boolean }) => {
        getLegalsModal(needToFillForm, () => onApplyClick({
            id: activeCompetition?.competitionId || '',
            shouldPublish,
            projectId,
        }));
    }
    
    return {
        sendProjectToCompetition,
    }
}

export default useCompetitionPanelActions;import { ActiveCompetitionSelector } from "shared/reducers/CompetitionActionPanel";
import { useDispatch, useSelector } from "react-redux";
import { useModal } from "core";
import { CompetitionActionPanelActions } from "shared/reducers/CompetitionActionPanel";
import urlApi from "shared/actions/urlApi";
import { ProjectAPI } from "@brg/api";
import { useToasts } from "@brg/ui";
import { CreateLinkTo } from "shared/constants/linkTo";
import { useHistory } from "react-router-dom";
import useQueryState from "./useQueryState";
import useCompetitionActions from "./useCompetitionActions";
import { useEffect } from "react";

const useCompetitionPanelActions = ({ projectId }: { projectId: string }) => {
    const activeCompetition = useSelector(ActiveCompetitionSelector);

    const { 
        onApplyClick, 
        setSelectedProjects, 
        getLegalsModal,
        needToFillForm
    } = useCompetitionActions(activeCompetition);

    useEffect(() => {
        setSelectedProjects([projectId]);
    }, [projectId]);
    
    const sendProjectToCompetition = ({
        projectId,
        shouldPublish,
    }: { projectId: string, shouldPublish: boolean }) => {
        getLegalsModal(needToFillForm, () => onApplyClick({
            id: activeCompetition?.competitionId || '',
            shouldPublish,
            projectId,
        }));
    }
    
    return {
        sendProjectToCompetition,
    }
}

export default useCompetitionPanelActions;